export {};

document.addEventListener('started-guest', () => {
    document.location.href = '/';
});

document.addEventListener('started-user', () => {
    if (app.user.user?.isSubscribed) {
        document.location.href = config.routes.activation_success;
    }
});
